const STORAGE_PREFIX = "reimagine_client_nav_viewed";

export const CLIENT_NAV_READ_STATE_CHANGED = "client-nav-read-state-changed";

export type ClientNavPage = "assessment" | "reports";

function getStorageKey(
  page: ClientNavPage,
  userId: number | string,
  projectId: number | string
): string {
  return `${STORAGE_PREFIX}:${page}:${userId}:${projectId}`;
}

function notifyReadStateChanged(detail: {
  page: ClientNavPage;
  userId: number | string;
  projectId: number | string;
}): void {
  try {
    window.dispatchEvent(new CustomEvent(CLIENT_NAV_READ_STATE_CHANGED, { detail }));
  } catch {
    // Ignore environments without window/CustomEvent
  }
}

export function isClientNavPageViewed(
  page: ClientNavPage,
  userId: number | string | null | undefined,
  projectId: number | string | null | undefined
): boolean {
  if (userId == null || projectId == null) {
    return false;
  }

  try {
    return localStorage.getItem(getStorageKey(page, userId, projectId)) === "1";
  } catch {
    return false;
  }
}

/** Marks a client sidebar destination as opened (clears the “New” menu badge). */
export function markClientNavPageViewed(
  page: ClientNavPage,
  userId: number | string | null | undefined,
  projectId: number | string | null | undefined
): void {
  if (userId == null || projectId == null) {
    return;
  }

  try {
    localStorage.setItem(getStorageKey(page, userId, projectId), "1");
    notifyReadStateChanged({ page, userId, projectId });
  } catch {
    // Ignore storage errors (private mode, quota, etc.)
  }
}
